<template>
  <div id="filterview">
    <!-- <pre><small>{{filter.getriebe}}</small></pre> -->
    <form v-on:submit.prevent="formatQuery">
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-x-6 mx-5 mt-1 mb-1">
        <div class="col-span-2">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 mb-1">
            <div>
              <fieldset class="inline-group">
                <input
                  type="radio"
                  id="nw"
                  name="nwgw"
                  value="Neuwagen"
                  v-model="filter.type"
                />
                <label for="nw" class="text-lg mr-5"> Neuwagen</label>
                <input
                  type="radio"
                  id="gw"
                  name="nwgw"
                  value="Gebrauchtwagen"
                  v-model="filter.type"
                />
                <label for="gw" class="text-lg mr-5"> Gebrauchtwagen</label>
              </fieldset>
            </div>
            <div>
              <fieldset class="inline-group" v-if="filter.type === 'Neuwagen'">
                <input
                  type="checkbox"
                  id="bestand"
                  name="auflager"
                  value="Bestand"
                  v-model="filter.aufLager"
                />
                <label for="bestand" class="text-lg mr-5"> Bestand</label>
                <input
                  type="checkbox"
                  id="vorlauf"
                  name="auflager"
                  value="Vorlauf"
                  v-model="filter.aufLager"
                />
                <label for="vorlauf" class="text-lg mr-5"> Vorlauf</label>
              </fieldset>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 mb-1">
            <div>
              <fieldset>
                <label for="hersteller" class="text-lg mr-5">Hersteller</label>
                <select
                  v-model="filter.hersteller"
                  class="mr-3 placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                >
                  <option v-for="hersteller in shownHersteller" v-bind:key="hersteller">
                    {{ hersteller }}
                  </option>
                </select>
                <input
                  type="text"
                  placeholder="Hersteller eingeben…"
                  v-model="filter.vhersteller"
                  class="mt-1 placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                />
              </fieldset>
            </div>
            <div>
              <fieldset>
                <label for="standort" class="text-lg mr-5">Standort</label>
                <select
                  v-model="filter.standort"
                  class="mr-3 placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                >
                  <option>Alle</option>
                  <option v-for="standort in standorte" v-bind:key="standort">
                    {{ standort }}
                  </option>
                </select>
              </fieldset>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 mb-1">
            <div>
              <fieldset>
                <label for="modell" class="text-lg mr-5">Modell </label>
                <input
                  type="text"
                  placeholder="Modell"
                  v-model="filter.modell"
                  class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                />
              </fieldset>
            </div>
            <div>
              <fieldset>
                <label for="version" class="text-lg mr-5">Version </label>
                <input
                  type="text"
                  placeholder="Version"
                  v-model="filter.version"
                  class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                />
              </fieldset>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 mb-1">
            <div>
              <fieldset v-if="filter.type === 'Neuwagen'">
                <label for="optionen" class="text-lg mr-5">Optionen </label>
                <input
                  type="text"
                  placeholder="(mit Komma trennen)"
                  v-model="filter.optionen"
                  class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                />
              </fieldset>
            </div>
            <div>
              <fieldset>
                <label for="preis">Preis</label>
                <div class="range-row">
                  <input
                    type="text"
                    placeholder="von"
                    v-model="filter.preis.from"
                    class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                  />
                  <span>–</span>
                  <input
                    type="text"
                    placeholder="bis"
                    v-model="filter.preis.to"
                    class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                  />
                </div>
              </fieldset>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 mb-1">
            <div class="col-span-2">
              <fieldset>
                <label for="erstzulassung">Erstzulassung</label>
                <div class="range-row" style="max-width: 24rem">
                  <input
                    type="month"
                    placeholder="von"
                    v-model="filter.erstzulassung.from"
                    class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                  />
                  <span>–</span>
                  <input
                    type="month"
                    placeholder="bis"
                    v-model="filter.erstzulassung.to"
                    class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                  />
                  <span
                    @click.prevent="
                      filter.erstzulassung = { from: null, to: null }
                    "
                    class="flex-none rounded-md hover:cursor-pointer border hover:bg-red-200 text-red-500 border-red-500 py-1 px-3 text-sm"
                  >
                    X
                  </span>
                </div>
              </fieldset>
            </div>
            <div></div>
          </div>
          <div class="mt-1" v-show="advancedFilters">
            <p class="mb-2">
              <small class="text-red-600"
                >Die folgende Ausstattungssuche ist experimentell und nur für
                bereits gepflegte Fahrzeuge.</small
              >
            </p>
            <input
              type="text"
              placeholder="Ausstattung suchen…"
              v-model="ausstattungSuche"
              class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-3 pr-3 text-sm focus:outline-none mb-2"
              style="width: 18rem"
            />
            <div
              v-for="grp in gefilterteAusstattungen"
              v-bind:key="grp.gruppe"
              class="mb-2"
            >
              <h4 class="text-sm font-bold text-gray-600 mt-2 mb-1">
                {{ grp.gruppe }}
              </h4>
              <div class="flex flex-wrap">
                <template v-for="item in grp.items">
                  <span
                    v-if="item.art === 'enum'"
                    v-bind:key="item.field + '::' + item.wert"
                    @click="toggleEnum(item)"
                    :class="[
                      'inline-flex items-center whitespace-no-wrap rounded-md border px-3 py-1 mr-2 mb-2 text-sm cursor-pointer select-none',
                      filter.enumsel[item.field] === item.wert
                        ? 'bg-schneider-petrol border-schneider-petrol text-white'
                        : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-100',
                    ]"
                  >
                    {{ item.label }}
                  </span>
                  <label
                    v-else
                    v-bind:key="chipKey(item)"
                    :class="[
                      'inline-flex items-center whitespace-no-wrap rounded-md border px-3 py-1 mr-2 mb-2 text-sm cursor-pointer select-none',
                      filter.ssettings.includes(chipKey(item))
                        ? 'bg-schneider-petrol border-schneider-petrol text-white'
                        : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-100',
                    ]"
                  >
                    <input
                      type="checkbox"
                      class="sr-only"
                      :value="chipKey(item)"
                      v-model="filter.ssettings"
                    />
                    {{ item.label }}
                  </label>
                </template>
              </div>
            </div>
          </div>
          <div class="mt-2 mb-0 flex flex-wrap items-center gap-2">
            <button
              type="button"
              class="whitespace-nowrap hover:cursor-pointer bg-gray-400 hover:bg-gray-500 text-white font-bold py-1 px-3 rounded-md"
              v-on:click.stop.prevent="advancedFilters = !advancedFilters"
            >
              Mehr Filter
            </button>
            <button
              type="submit"
              @click="formatQuery"
              class="whitespace-nowrap bg-schneider-petrol hover:bg-schneider-petrol-dark text-white font-bold py-1 px-5 rounded-md"
            >
              Suchen
            </button>
            <button
              type="button"
              @click="cleanAttributes"
              class="whitespace-nowrap bg-gray-400 hover:bg-gray-500 text-white font-bold py-1 px-5 rounded-md"
            >
              Löschen
            </button>
            <button
              type="button"
              class="whitespace-nowrap sm:ml-auto bg-white border border-schneider-petrol text-schneider-petrol hover:bg-schneider-petrol hover:text-white font-bold py-1 px-5 rounded-md"
              @click.prevent="legende = !legende"
            >
              Standort-Legende
            </button>
            <div id="legende" v-show="legende">
              <b>Unsere Standorte:</b><br />
              <a
                href="https://www.dieschneidergruppe.de/chemnitz"
                target="_blank"
                >Zentrallagerplatz<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/sportcenter-roehrsdorf"
                target="_blank"
                >02 - Röhrsdorf<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/burgstaedt"
                target="_blank"
                >03 - Burgstädt<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/frankenberg"
                target="_blank"
                >04 - Frankenberg<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/oederan"
                target="_blank"
                >05 - Oederan<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/standorte/business-center-mittweida"
                target="_blank"
                >06 - Mittweida<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/chemnitz"
                target="_blank"
                >07 - Chemnitz<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/business-center-chemnitz"
                target="_blank"
                >08 - Chemnitz Business-Center<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/zwickau"
                target="_blank"
                >09 - Zwickau<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/business-center-hof"
                target="_blank"
                >10 - Hof Business-Center<br
              /></a>
              <a href="https://www.dieschneidergruppe.de/plauen" target="_blank"
                >11 - Plauen<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/land-rover-hof"
                target="_blank"
                >12 - Hof BOR<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/zwickau"
                target="_blank"
                >13 - Zwickau Business-Center<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/zwickau"
                target="_blank"
                >13 - Zwickau Lager<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/freiberg"
                target="_blank"
                >14 - Freiberg<br
              /></a>
              <a
                href="https://www.dieschneidergruppe.de/plauen-seat"
                target="_blank"
                >15 - Plauen SEAT</a
              >
            </div>
          </div>
          <div class="col-span-2 mt-2" v-if="ausgewaehlteLabels.length > 0">
            <p class="text-sm text-gray-500">
              Ausgewählte Ausstattung: {{ ausgewaehlteLabels.join(" | ") }}
            </p>
          </div>
        </div>
        <div class="col-span-2">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 mb-1 mt-2">
            <div>
              <fieldset>
                <br />
                <label for="farbe" class="text-lg mr-5">Farbe </label>
                <input
                  type="text"
                  placeholder="Farbe"
                  v-model="filter.farbe"
                  class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                />
              </fieldset>
            </div>
            <div>
              <div>
                <br />
                <fieldset>
                  <label for="kw">KW</label>
                  <div class="range-row">
                    <input
                      type="text"
                      placeholder="von"
                      v-model="filter.kw.from"
                      class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                    />
                    <span>–</span>
                    <input
                      type="text"
                      placeholder="bis"
                      v-model="filter.kw.to"
                      class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                    />
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="mt-3">
              <div>
                <fieldset>
                  <label for="Eigentümer" class="text-lg mr-5"
                    >Eigentümer</label
                  >
                  <select
                    v-model="filter.ahid"
                    class="mr-3 placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                  >
                    <option
                      v-for="ahid in eigentuemer"
                      v-bind:key="ahid.value"
                      :value="ahid.value"
                    >
                      {{ ahid.key }}
                    </option>
                  </select>
                </fieldset>
              </div>
            </div>
            <div class="mt-3">
              <fieldset>
                <label for="Akkukap">Batteriekapazität (kWh)</label>
                <div class="range-row">
                  <input
                    type="text"
                    placeholder="von"
                    v-model="filter.akkukap.from"
                    class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                  />
                  <span>–</span>
                  <input
                    type="text"
                    placeholder="bis"
                    v-model="filter.akkukap.to"
                    class="placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                  />
                </div>
              </fieldset>
            </div>
            <div class="mt-3">
              <fieldset>
                <label for="Kraftstoff" class="text-lg mr-5">Kraftstoff</label>
                <select
                  v-model="filter.kraftstoff"
                  class="mr-3 placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                >
                  <option>Alle</option>
                  <option
                    v-for="kraftstoff in kraftstoffe"
                    v-bind:key="kraftstoff"
                  >
                    {{ kraftstoff }}
                  </option>
                </select>
              </fieldset>
            </div>
            <div class="mt-3">
              <fieldset>
                <label for="Getriebe" class="text-lg mr-5">Getriebe</label>
                <select
                  v-model="filter.getriebe"
                  class="mr-3 placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                >
                  <option>Alle</option>
                  <option v-for="getrieb in getriebe" v-bind:key="getrieb">
                    {{ getrieb }}
                  </option>
                </select>
              </fieldset>
            </div>
            <div class="mt-3">
              <fieldset>
                <label for="Aktion" class="text-lg mr-5 text-green-400"
                  >Aktion</label
                >
                <select
                  v-model="filter.aktion"
                  class="mr-3 placeholder-gray-500 border border-gray-500 focus:border-schneider-petrol rounded-md pt-1 pb-1 pl-2 pr-2 text-sm focus:outline-none"
                >
                  <option>Keine Auswahl</option>
                  <option v-for="aktion in aktionen" v-bind:key="aktion.key">
                    {{ aktion.value }}
                  </option>
                </select>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- <div>
      <small>
        <pre>{{ filter }}</pre>
      </small>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterActive: false,
      filter: {
        type: "Neuwagen",
        aufLager: ["Bestand"],
        hersteller: "Alle",
        vhersteller: "",
        modell: "",
        erstzulassung: {
          from: null,
          to: null,
        },
        preis: {
          from: "",
          to: "",
        },
        kw: {
          from: "",
          to: "",
        },
        farbe: "",
        filiale: "Alle",
        standort: "Alle",
        ahid: "Alle",
        kraftstoff: "Alle",
        getriebe: "Alle",
        aktion: "Keine Auswahl",
        version: "",
        akkukap: {
          from: "",
          to: "",
        },
        ssettings: [],
        enumsel: {},
      },
      ausstattungSuche: "",
      baseHersteller: [
        "Alle",
        "Renault",
        "Alpine",
        "Seat",
        "Jaguar",
        "Land Rover",
        "Dacia",
        "CUPRA",
        "Mazda",
        "MG",
        "BAIC",
        "SERES",
        "DFM",
        "DFSK",
        "JAC",
        "SWM",
        "Forster",
        "Karmann",
        "Eura Mobil",
        "Caravelair",
        "Etrusco",
        "Sonstige",
      ],
      usedHersteller: [],
      standorte: [],
      eigentuemer: [],
      kraftstoffe: [],
      getriebe: [],
      aktionen: [],
      advancedFilters: false,
      legende: false,
    };
  },
  methods: {
    cleanAttributes() {
      this.filter = {
        type: "Neuwagen",
        aufLager: ["Bestand"],
        hersteller: "Alle",
        vhersteller: "",
        modell: "",
        erstzulassung: {
          from: null,
          to: null,
        },
        preis: {
          from: "",
          to: "",
        },
        kw: {
          from: "",
          to: "",
        },
        farbe: "",
        filiale: "Alle",
        standort: "Alle",
        ahid: "Alle",
        kraftstoff: "Alle",
        getriebe: "Alle",
        aktion: "Keine Auswahl",
        version: "",
        akkukap: {
          from: "",
          to: "",
        },
        ssettings: [],
        enumsel: {},
      };

      this.ausstattungSuche = "";
    },
    chipKey(item) {
      if (item.art === "keyword") return `kw::${item.field}::${item.term}`;
      if (item.art === "bitbool") return `bit::${item.field}::${item.bit}`;
      return item.field;
    },
    toggleEnum(item) {
      if (this.filter.enumsel[item.field] === item.wert) {
        this.$delete(this.filter.enumsel, item.field);
      } else {
        this.$set(this.filter.enumsel, item.field, item.wert);
      }
    },
    formatQuery() {
      window.document.getElementById("main").scrollTop = 0;
      this.advancedFilters = false;
      /**
       * This contains a prototype query builder. Will be removed in production.
       */
      let data = {};

      let alias = this.filter.type;
      let aufLager = null;
      if (
        this.filter.aufLager.length === 1 &&
        this.filter.aufLager.includes("Bestand")
      )
        aufLager = true;
      if (
        this.filter.aufLager.length === 1 &&
        this.filter.aufLager.includes("Vorlauf")
      )
        aufLager = false;

      if (this.filter.aufLager.length === 2 || alias === "Gebrauchtwagen")
        aufLager = null;
      data.auflager = aufLager;

      if (this.filter.hersteller !== "Alle")
        data.hersteller = this.filter.hersteller;

      if (this.filter.aktion !== "Keine Auswahl")
        data.aktion = this.filter.aktion;

      if (this.filter.hersteller === "Sonstige" && !this.filter.vhersteller) {
        this.filter.hersteller = "Alle";
        data.hersteller = null;
      }

      if (this.filter.vhersteller) {
        data.hersteller = this.filter.vhersteller;
        this.filter.hersteller = "Sonstige";
      }

      if (this.filter.modell) data.modell = this.filter.modell;
      if (this.filter.version) data.version = this.filter.version;
      if (this.filter.farbe) data.farbe = this.filter.farbe;
      data.standort = null;
      if (this.filter.standort !== "Alle") data.standort = this.filter.standort;

      data.ahid = null;
      if (this.filter.ahid !== "Alle") data.ahid = this.filter.ahid;

      data.kraftstoff = null;
      if (this.filter.kraftstoff !== "Alle")
        data.kraftstoff = this.filter.kraftstoff;

      data.getriebe = null;
      if (this.filter.getriebe !== "Alle") data.getriebe = this.filter.getriebe;

      if (this.filter.optionen) {
        let fop = this.filter.optionen;
        fop = fop
          .split(/,/g)
          .map((x) => x.trim())
          .filter((x) => !!x);
        data.optionen = fop;
      } else data.optionen = [];

      let filterPart = {
        and: [],
      };

      if (data.auflager !== null)
        filterPart.and.push({
          field: "auflager",
          type: "match",
          operator: "is",
          query: data.auflager,
        });

      if (data.hersteller)
        filterPart.and.push({
          field: alias === "Neuwagen" ? "hersteller_dispo" : "hersteller",
          type: "match",
          operator: "is",
          query: data.hersteller,
        });

      if (data.aktion)
        filterPart.and.push({
          field: "aktionsBezeichnung",
          type: "match",
          operator: "is",
          query: data.aktion,
        });

      if (data.modell)
        filterPart.and.push({
          field: alias === "Neuwagen" ? "modell_dispo" : "modell",
          type: "wildcard",
          operator: "is",
          query: data.modell,
        });

      if (data.farbe)
        filterPart.and.push({
          field:
            alias === "Neuwagen"
              ? "herstellerfarbe"
              : "herstellerfarbe_fzgtool",
          type: "wildcard",
          operator: "is",
          query: data.farbe,
        });

      if (data.version)
        filterPart.and.push({
          field:
            alias === "Neuwagen" ? "model_text" : "ausstattungslinie_fzgtool",
          type: "wildcard",
          operator: "is",
          query: data.version,
        });

      if (data.optionen.length > 0)
        for (let o of data.optionen) {
          filterPart.and.push({
            field: "optionscodes",
            type: "wildcard",
            operator: "is",
            query: o,
          });
        }
      if (this.filter.preis.from || this.filter.preis.to)
        filterPart.and.push({
          field: alias === "Neuwagen" ? "listenpreis_upe_brutto" : "wwwpreis",
          type: "range",
          operator: "is",
          query: [
            this.filter.preis.from ? parseInt(this.filter.preis.from) : 0,
            this.filter.preis.to ? parseInt(this.filter.preis.to) : 1000000,
          ],
        });

      if (this.filter.kw.from || this.filter.kw.to)
        filterPart.and.push({
          field: "leistungkw",
          type: "range",
          operator: "is",
          query: [
            this.filter.kw.from ? parseInt(this.filter.kw.from) : 0,
            this.filter.kw.to ? parseInt(this.filter.kw.to) : 1000000,
          ],
        });

      if (this.filter.akkukap.from || this.filter.akkukap.to)
        filterPart.and.push({
          field: "batteriekapazitaet",
          type: "range",
          operator: "is",
          query: [
            this.filter.akkukap.from ? parseInt(this.filter.akkukap.from) : 0,
            this.filter.akkukap.to ? parseInt(this.filter.akkukap.to) : 100000,
          ],
        });

      if (this.filter.erstzulassung.from || this.filter.erstzulassung.to)
        filterPart.and.push({
          field:
            alias === "Neuwagen" ? "erstzulassung" : "erstzulassung_fzgtool",
          type: "range",
          operator: "is",
          query: [
            this.filter.erstzulassung.from
              ? `${String(this.filter.erstzulassung.from).split(/-/g)[0]}-${
                  String(this.filter.erstzulassung.from).split(/-/g)[1]
                }-01`
              : `1900-01-01`,
            this.filter.erstzulassung.to
              ? `${String(this.filter.erstzulassung.to).split(/-/g)[0]}-${
                  String(this.filter.erstzulassung.to).split(/-/g)[1]
                }-31`
              : `2050-12-31`,
          ],
        });

      if (this.filter.ssettings.length > 0) {
        for (let key of this.filter.ssettings) {
          let item = this.ssettingMap[key];
          if (!item) continue;
          if (item.art === "bitmask") {
            filterPart.and.push({
              field: item.field,
              type: "range",
              operator: "is",
              query: [1, 999999],
            });
          } else if (item.art === "bitbool") {
            let orClauses = [];
            for (let v = 0; v < 64; v++) {
              if (v & item.bit)
                orClauses.push({
                  field: item.field,
                  type: "match",
                  operator: "is",
                  query: v,
                });
            }
            filterPart.and.push({ or: orClauses });
          } else if (item.art === "keyword") {
            filterPart.and.push({
              field: item.field,
              type: "wildcard",
              operator: "is",
              query: item.term,
            });
          } else {
            filterPart.and.push({
              field: item.field,
              type: "match",
              operator: "is",
              query: true,
            });
          }
        }
      }
      for (let field of Object.keys(this.filter.enumsel)) {
        let wert = this.filter.enumsel[field];
        if (wert === undefined || wert === null || wert === "") continue;
        filterPart.and.push({
          field: field,
          type: "match",
          operator: "is",
          query: wert,
        });
      }

      if (data.standort) {
        filterPart.and.push({
          field: "standort",
          type: "match",
          operator: "is",
          query: data.standort,
        });
      }

      if (data.ahid) {
        filterPart.and.push({
          field: "ahid",
          type: "match",
          operator: "is",
          query: data.ahid,
        });
      }

      if (data.kraftstoff) {
        filterPart.and.push({
          field: "kraftstoff",
          type: "match",
          operator: "is",
          query: data.kraftstoff,
        });
      }

      if (data.getriebe) {
        filterPart.and.push({
          field: "getriebe",
          type: "match",
          operator: "is",
          query: data.getriebe,
        });
      }

      let filterArray = [filterPart];

      let dataObj = {
        pagination: {
          page: 1,
          perPage: 50,
        },
        order:
          alias === "Neuwagen"
            ? "listenpreis_upe_brutto:desc"
            : "wwwpreis:desc",
        filter: filterArray,
      };

      this.$emit(
        "change",
        dataObj,
        alias === "Neuwagen" ? "cars_vk" : "cars_vk_gw"
      );
    },
  },
  computed: {
    ssettingMap() {
      const map = {};
      for (const item of this.$ausstattungenMeta) {
        if (item.art === "enum" || item.nurDetail) continue;
        map[this.chipKey(item)] = item;
      }
      return map;
    },
    gefilterteAusstattungen() {
      const q = this.ausstattungSuche.trim().toLowerCase();
      const gruppen = {};
      const reihenfolge = [];
      for (const item of this.$ausstattungenMeta) {
        if (item.nurDetail) continue;
        if (
          q &&
          !item.label.toLowerCase().includes(q) &&
          !item.field.toLowerCase().includes(q)
        )
          continue;
        if (!gruppen[item.gruppe]) {
          gruppen[item.gruppe] = [];
          reihenfolge.push(item.gruppe);
        }
        gruppen[item.gruppe].push(item);
      }
      return reihenfolge.map((g) => ({ gruppe: g, items: gruppen[g] }));
    },
    ausgewaehlteLabels() {
      const labels = [];
      for (const key of this.filter.ssettings) {
        const item = this.ssettingMap[key];
        if (item) labels.push(item.label);
      }
      for (const field of Object.keys(this.filter.enumsel)) {
        const wert = this.filter.enumsel[field];
        const item = this.$ausstattungenMeta.find(
          (a) => a.art === "enum" && a.field === field && a.wert === wert
        );
        if (item) labels.push(item.label);
      }
      return labels;
    },
    shownHersteller() {
      return this.filter.type === "Neuwagen"
        ? this.baseHersteller
        : this.usedHersteller;
    },
  },
  watch: {
    advancedFilters(val) {
      if (val) {
        window.document
          .getElementById("main")
          .classList.remove("overflow-y-hidden");
      } else {
        window.document
          .getElementById("main")
          .classList.add("overflow-y-hidden");
      }
    },
  },
  beforeMount() {
    // Aktionsliste + GW-Herstellerliste kommen über das Gateway (enum-Service jr4:5006).
    this.$http
      .get(`${this.$endpoints.esapi}/e/getActions`)
      .then((res) => {
        if (res.status === 200) {
          this.aktionen = res.data.data.sort().map((x) => ({ key: x, value: x }));
        }
      })
      .catch((err) => console.error(err));
    this.$http
      .get(`${this.$endpoints.esapi}/e/getUsedCars`)
      .then((res) => {
        if (res.status === 200) {
          this.usedHersteller = ["Alle", ...res.data.data.sort(), "Sonstige"];
        }
      })
      .catch((err) => console.error(err));
    this.standorte = this.$standorte;
    this.eigentuemer = this.$eigentuemer;
    this.kraftstoffe = this.$kraftstoff;
    this.getriebe = this.$getriebe;
    this.cleanAttributes();
  },
};
</script>

<style>
/* Formular-Raster: Label über dem Feld, Felder volle Spaltenbreite (ausgerichtet).
   Ausgenommen: Radio-/Checkbox-Gruppen (.inline-group) bleiben horizontal. */
#filterview fieldset:not(.inline-group) {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
#filterview fieldset:not(.inline-group) > label {
  margin: 0 0 1px 0;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.1;
  color: #374151;
}
/* Felder nur so breit wie nötig (max ~15rem), linksbündig unter dem Label —
   nicht die ganze Spalte. Auf schmalen Spalten schrumpfen sie mit. */
#filterview fieldset:not(.inline-group) > select,
#filterview fieldset:not(.inline-group) > input {
  width: 100%;
  max-width: 15rem;
}
/* Kompakte Feldhöhe — mehr vertikaler Raum für die Trefferliste */
#filterview input:not([type="radio"]):not([type="checkbox"]),
#filterview select {
  padding-top: 2px;
  padding-bottom: 2px;
  line-height: 1.25;
}
/* Von–bis-Zeilen: beide Felder nebeneinander, begrenzt wie die Einzelfelder */
#filterview .range-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  max-width: 15rem;
}
#filterview .range-row input {
  width: 100%;
  min-width: 0;
}

#legende {
  z-index: 1000;
  position: fixed;
  right: 1rem;
  top: 0.1rem;
  background-color: white;
  margin: 1rem;
  padding: 1rem;
}
</style>